import { render, staticRenderFns } from "./BaseFrame.vue?vue&type=template&id=9fa9953a&"
import script from "./BaseFrame.vue?vue&type=script&lang=js&"
export * from "./BaseFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports